import React, { useRef } from 'react';
import Lightbox from "yet-another-react-lightbox";
// import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Video from "yet-another-react-lightbox/dist/plugins/video/index";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails/index";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom/index";
import { useSelector } from "react-redux";

const YetAnotherLightbox = function({
    mediaItems,
    showThumbnails,
    showImageCount,
    onClose,
    onClickNext,
    onClickPrev,
    onClickThumbnail,
    onClickShowModal
}) {
    const thumbnailsRef = useRef(null);
    const zoomRef = useRef(null);

    const mapImage = (mediaItem) => {
        return {
            type: "image",
            src: mediaItem.fullSrc,
            alt: mediaItem.alt
        }
    }

    const mapVideo = (mediaItem) => {
        return {
            type: "video",
            width: 1280,
            height: 720,
            poster: mediaItem.previewSrc,
            sources: [
                {
                    src: mediaItem.fullSrc,
                    type: mediaItem.mimeType,
                },
            ],
        }
    }

    const { visible, index } = useSelector(state => state.lightboxImages);
    const remappedMediaItems = mediaItems.map(mediaItem => {
        return mediaItem.type === "video" ? mapVideo(mediaItem) : mapImage(mediaItem);
    });

    return <Lightbox
        index={index}
        open={visible}
        close={onClose}
        slides={remappedMediaItems}
        plugins={[Video, Thumbnails, Zoom]}
        thumbnails={{ ref: thumbnailsRef }}
        zoom={{ ref: zoomRef }}
        video={{
            controls: true,
            playsInline: true,
            autoPlay: true,
            loop: false,
            muted: true
        }}
    />;
}

export default YetAnotherLightbox;
